import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "./auth/authSlice";
import contactReducer from "./contact/contactSlice";
import redirectReducer from "./redirect/redirectSlice";
import accountInfoReducer from "./accountInfo/accountInfoSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    contact: contactReducer,
    redirect: redirectReducer,
    accountInfos: accountInfoReducer,
});

export default rootReducer;
